import styled from "styled-components";
import {Box, BoxTitle } from "./../../common/Box";

export const Wrapper = styled(Box)`
  height: 340px;
`;

export const Title = styled(BoxTitle)`
  display: flex;
`;